import type { StepConfigFor } from '../getStepConfig.types.ts';

export const IdVerificationStepConfig = {
  title: ({ isHealthcareProvider }) => (isHealthcareProvider ? 'ID Verification' : 'Verify Your Identity'),
  statuses: {
    NOT_STARTED: {
      label: 'Not Started',
      cta: 'Verify Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with verifying their identity'
          : 'Please complete your identity verification with Digital ID',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with verifying their identity'
          : 'Please complete your identity verification with Digital ID',
    },
    PENDING: {
      label: 'Under Review',
      cta: 'Resubmit',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their identity documents. Please review them and verify their identity'
          : 'You have submitted your identity documents. We are reviewing them and will update you shortly',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their identity documents. We need to review them and update the status'
          : 'Your identity documents are being reviewed. We will update you shortly',
    },
    COMPLETED: {
      label: 'Verified',
      cta: 'View',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully verified their identity'
          : 'You have successfully verified your identity',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully verified their identity'
          : 'You have successfully verified your identity',
    },
    ERROR: {
      label: 'Needs Resubmission',
      cta: 'Resubmit Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There was an issue with the identity verification. The patient will need to resubmit their identity documents again'
          : 'There was an issue while verifying your identity. Please try again',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There was an issue with the identity verification. The patient will need to resubmit their identity documents again'
          : 'There was an issue while verifying your identity. Please try again',
    },
  },
} satisfies StepConfigFor<'ID_VERIFICATION'>;
